/**
 * Client-side mirror of the soft checks in server codecs/slide-codec.ts
 * (validateField). Warnings only — the save never blocks on these; they
 * render inline under the field for instant feedback while typing.
 */
const BRITISH_SUBS: [RegExp, string][] = [
  [/\borgani[zs]ation\b/gi, 'organisation'],
  [/\bcolor\b/gi, 'colour'],
  [/\boptimi[zs]e\b/gi, 'optimise'],
  [/\brealize\b/gi, 'realise'],
  [/\brecognize\b/gi, 'recognise'],
  [/\banalyze\b/gi, 'analyse'],
  [/\bcenter\b/gi, 'centre'],
];

export function fieldWarnings(primitive: string, value: string): string[] {
  const warnings: string[] = [];

  if (primitive === 'Title') {
    const words = value.split(/\s+/).filter(Boolean).length;
    if (words > 14) {
      warnings.push(`Title is ${words} words: consider cutting, or a smaller size.`);
    }
  }

  for (const [re, repl] of BRITISH_SUBS) {
    re.lastIndex = 0;
    const m = re.exec(value);
    if (m && m[0].toLowerCase() !== repl) {
      warnings.push(`British spelling: "${m[0]}" should be "${repl}"`);
    }
  }

  return warnings;
}

/** Fields whose extracted text contains nested JSX (accent spans etc) —
 *  saving would flatten the styling, so the UI sends those to chat. */
export function hasNestedJsx(value: string): boolean {
  return /<[A-Za-z][^>]*>/.test(value);
}
